<div id="grievance-committee" class="inner-page">
  <div class="container-fluid px-lg-5">
    <h2 class="title">Student Grievance Redressal Committee (SGRC)</h2>
    <p class="inner-lead mt-3">
      The SGRC at Shah Satnam Ji Girls' College is constituted to provide a mechanism for redressal of students'
      grievances and to ensure transparency in all academic and administrative activities.
    </p>

    <hr class="divider">

    <div class="table-responsive-inner mt-4">
      <table class="inner-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Role</th>
            <th>Contact Number</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Dr. Geeta Monga</strong></td>
            <td>Chairman</td>
            <td>9416413336</td>
          </tr>
          <tr>
            <td><strong>Dr. Dilawar Singh</strong></td>
            <td>Member</td>
            <td>9817371075</td>
          </tr>
          <tr>
            <td><strong>Dr. Rishu Tomar</strong></td>
            <td>Member</td>
            <td>8607225777</td>
          </tr>
          <tr>
            <td><strong>Dr. Monika</strong></td>
            <td>Member</td>
            <td>9466471013</td>
          </tr>
          <tr>
            <td><strong>Ms. Poonam Dhamija</strong></td>
            <td>Member</td>
            <td>9991872781</td>
          </tr>
          <tr>
            <td><strong>Dr. Chanchal Rani</strong></td>
            <td>Member</td>
            <td>9416806620</td>
          </tr>
          <tr>
            <td><strong>Dr. Babul Lal</strong></td>
            <td>Member</td>
            <td>9466670056</td>
          </tr>
          <tr>
            <td><strong>Dr. Anil</strong></td>
            <td>Outside Expert</td>
            <td>9896288861</td>
          </tr>
          <tr>
            <td><strong>Mr. Divyansh</strong></td>
            <td>Student Representative</td>
            <td>9817080243</td>
          </tr>
          <tr>
            <td><strong>Ms. Priyanka</strong></td>
            <td>Student Representative</td>
            <td>9350051639</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="mt-section">
      <h4 class="section-subtitle">Official Documents</h4>
      <a class="pdf-download-btn" href="assets/pdf/grievances/Committee-6.pdf" target="_blank">
        <i class="fa fa-file-pdf-o me-2"></i>View Official Notification (PDF)
      </a>
    </div>

  </div>
</div>